//
import { UserSellerModel } from '@/models'

/**
 *
 */
const fetchById = async id => {
    //
    const includes = ['hr_employee.g_branch_office'],
        appends = [
            //'branch_offices',
            'is_ground_seller',
            'commissions',
            'customers',
            'seller_type',
        ]

    //
    try {
        //
        let user = await UserSellerModel.include(includes)
            .append(appends)
            .find(id)

        //
        return user
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchById
